import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IconButtonComponent } from "@components/icon-button/icon-button.component";
import { SelectorComponent } from "@components/selector/selector.component";
import _ from "lodash";
import { Subject } from "rxjs";
import { SkogsvardAtgardsGrupp, SkogsvardAtgardsTyp } from "~app/common/models/constants";
import { Atgard } from "~app/features/virkeskop/models/atgard-models";
import { SkogsVardRowType } from "~app/features/virkeskop/models/skogsvard/createskogsvard-models";
import { SkogsvardService } from "~app/features/virkeskop/services/skogsvard.service";

@Component({
    selector: "rask-skogsvard-create-row",
    styleUrls: ["./skogsvard-create-row.component.scss"],
    templateUrl: "./skogsvard-create-row.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectorComponent,
        FormsModule,
        IconButtonComponent
    ]
})
export class SkogsvardCreateRowComponent implements OnDestroy {
    @Input() allSkogsvardGrupp: string[];
    @Input() canDelete: boolean;
    @Output() deleted = new EventEmitter<number>();
    @Input() index: number;
    @Input({ required:true }) isSkogsvardKontrakt: boolean;
    @Input() readonly = false;
    @Output() rowChanged = new EventEmitter<void>();
    @Input() rowType: SkogsVardRowType;

    protected skogsvardTyper = [];

    private readonly destroySrc = new Subject<void>();
    private readonly skogsvardService = inject(SkogsvardService);

    ngOnDestroy(): void {
        this.destroySrc.next();
        this.destroySrc.complete();
    }

    protected delete(): void {
        if (this.readonly) {
            return;
        }
        this.deleted.emit(this.index);
    }

    protected skogsvardGruppChanged(grupp: string) {
        this.skogsvardService.getSkogsvardTyper(grupp).subscribe(typer => {
            this.rowType.skogsvardTyp = null;

            if (this.isSkogsvardKontrakt && grupp === SkogsvardAtgardsGrupp.rojning) {
                const allowedSkogsvardsTyper = [
                    SkogsvardAtgardsTyp.nsRojning,
                    SkogsvardAtgardsTyp.hyggesrensning,
                    SkogsvardAtgardsTyp.plantrojning,
                    SkogsvardAtgardsTyp.slutrojning,
                    SkogsvardAtgardsTyp.siktrojning,
                    SkogsvardAtgardsTyp.nsSiktrojning
                ];

                this.skogsvardTyper = typer.filter(typ => allowedSkogsvardsTyper.includes(typ));
            } else if(Atgard.isPlantleverans(grupp)) {
                this.rowType.skogsvardTyp = SkogsvardAtgardsTyp.plantleverans;
            } else if(Atgard.isOvrigt(grupp)) {
                this.skogsvardTyper = typer;
                this.rowType.skogsvardTyp = SkogsvardAtgardsTyp.ovrigt;
            } else {
                this.skogsvardTyper = typer;
            }
        });

        if (!_.isNil(grupp)) {
            this.rowChanged.emit();
        }
    }

    protected skogsvardTypChanged(typ: string) {
        if (!_.isNil(typ)) {
            this.rowChanged.emit();
        }
    }

    protected visaTypDropdown() {
        return !Atgard.isPlantleverans(this.rowType.skogsvardGrupp);
    }
}
